import React from 'react'
import {
  DsFade,
  DsFadeProps,
  DsStack,
  DsStackProps
} from '@am92/react-design-system'

interface IPageWrapperProps extends DsStackProps {
  TransitionProps?: DsFadeProps
}

const PageWrapper: React.FC<IPageWrapperProps> = props => {
  const { TransitionProps, ...restProps } = props

  return (
    <DsFade in timeout={{ enter: 500 }} {...TransitionProps}>
      <DsStack
        direction='column'
        spacing={{
          xs: 'var(--ds-spacing-mild)',
          md: 'var(--ds-spacing-hot)'
        }}
        flexGrow={1}
        {...restProps}
        sx={{
          py: {
            xs: 'var(--ds-spacing-warm)',
            lg: 'var(--ds-spacing-molten)'
          },
          px: {
            xs: 'var(--ds-spacing-bitterCold)',
            lg: 'var(--ds-spacing-hot)'
          },
          ...restProps?.sx
        }}
      />
    </DsFade>
  )
}

export default PageWrapper
